export default {
  methods: {
    api(name, args, callback) {
      if (!args) args = {}
      args.locale = this.$store.state.locale
      const entry = Kii.serverCodeEntry(name)
      entry.execute(args).then(params => {
        const execResult = params[2]
        const rv = execResult.getReturnedValue()
        if (callback) callback(rv.returnedValue)
      })
    },
    async serverCode(name, args) {
      if (!args) args = {}
      args.locale = this.$store.state.locale
      const entry = Kii.serverCodeEntry(name)
      const params = await entry.execute(args)
      const execResult = params[2]
      const rv = execResult.getReturnedValue()
      return rv.returnedValue
    },
    // 共通確認ダイアログ。はい=true / いいえ=false
    // 例: if (await this.confirmDialog({ title: '実行しますか？' })) { ... }
    confirmDialog({ title = '', message = '', yesLabel, noLabel } = {}) {
      return new Promise(resolve => {
        this.$modal.show('confirm-dialog', {
          title,
          message,
          yesLabel,
          noLabel,
          resolve,
        })
      })
    },
  },
}
